module.exports = __webpack_public_path__ + "static/media/jakarta.bb0307af.svg";